<template>
    <div class="detail">
        <detail-header>详情</detail-header>
        <div class="container">
            <template v-if="$route.query.mode == 'ARTICLE'">
                <h1 class="title">
                    {{ info.title }}
                </h1>
                <div class="find">
                    <div class="findNumber">观看：  {{info.createDate}}</div>
                    <div class="tit">{{ info.category.name }}</div>
                </div>
                <div class="content"  v-html="info.articleData.content" >
                    <p class="p" v-html="info.articleData.content"></p>
                </div>
            </template>

            <template v-if="$route.query.mode == 'PICTURE'">
                <h1 class="title">
                    {{ pictureInfo.introduce }}
                </h1>
                <div class="find">
                    <div class="findNumber">观看：  {{pictureInfo.createDate}}</div>
                    <div class="tit">{{ pictureInfo.category.name }}</div>
                </div>
                <div class="content"  v-html="pictureInfo.description"></div>
            </template>
            <div class="pages">
                <router-link 
                    tag="div" 
                    class="prev"
                    :to="{name: 'Detail',query:{id: prveInfo.id, mode: prveInfo.articleData ? 'ARTICLE' : 'PICTURE'}}"
                >
                    <span>上一篇</span>
                    {{prveInfo.title}}
                </router-link>
                <router-link 
                    tag="div" 
                    class="next"
                    :to="{name: 'Detail',query:{id: nextInfo.id, mode: nextInfo.articleData ? 'ARTICLE' : 'PICTURE'}}"
                >
                    <span>下一篇</span>
                    {{nextInfo.title}}
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from '../../components/Header';
export default {
    name: 'detail',
    components: {
        DetailHeader
    },
    data() {
        return {
            info: {
                category: {
                    name: ''
                },
                articleData: {
                    content: ''
                }
            },
            pictureInfo: {
                category: {
                    name: ''
                },
            },
            prveInfo: {
                title: ''
            },
            nextInfo: {
                title: ''
            }
        }
    },
    mounted() {
        if(this.$route.query.mode == 'ARTICLE'){
            let {id, mode} = this.$route.query
            this.getContentById(id, mode).then(res=>{
                this.info = res.data.content
                console.log( this.info);
            }).catch(err=>{
                console.log(err.response);
            })
        }else if(this.$route.query.mode == 'PICTURE'){
            let {id, mode} = this.$route.query
            this.getContentById(id, mode).then(res=>{
                this.pictureInfo = res.data.content
                console.log(this.pictureInfo);
            }).catch(err=>{
                console.log(err.response);
            })
        }
        
        this.getPrevContent(this.$route.query.id)   //上一篇
        this.getNextContent(this.$route.query.id)   //下一篇
      
        
    },
    watch: {
        $route() {
            if(this.$route.query.mode == 'ARTICLE'){
                let {id, mode} = this.$route.query
                this.getContentById(id, mode).then(res=>{
                    this.info = res.data.content
                    console.log( this.info);
                }).catch(err=>{
                    console.log(err.response);
                })
            }else if(this.$route.query.mode == 'PICTURE'){
                let {id, mode} = this.$route.query
                this.getContentById(id, mode).then(res=>{
                    console.log(res);
                }).catch(err=>{
                    console.log(err.response);
                })
            }
            this.getPrevContent(this.$route.query.id)   //上一篇
            this.getNextContent(this.$route.query.id)   //下一篇
        }
    },
    methods: {
        // 根据id查询文章
        getContentById(contentId,contentType) {
            return new Promise((resolve,reject)=>{
                this.$axios({
                    url: this.$config.baseUrl + '/lxcia/separatio/get/contentbyid',
                    method: 'GET',
                    params: {
                        contentId,
                        contentType
                    }
                }).then(res => {
                    if(res.data.code == 0){
                        resolve(res)
                    }
                }).catch(err => {
                    reject(err)
                }) 
            })
        },
        // 获取上一篇
        getPrevContent(currentId) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/pre',
                method: 'GET',
                params: {
                    currentId
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.prveInfo = res.data.content
                    console.log(this.prveInfo);
                }else {
                    this.prveInfo.title = res.data.errorMsg
                    console.log(this.prveInfo.title);
                }
            }).catch(err => {
                console.log(err.response);
            })
        },
        // 获取下一篇
        getNextContent(currentId) {
            this.$axios({
                url: this.$config.baseUrl + '/lxcia/separatio/get/next',
                method: 'GET',
                params: {
                    currentId
                }
            }).then(res => {
                if(res.data.code == 0){
                    this.nextInfo = res.data.content
                    console.log(this.nextInfo);
                }else {
                    this.nextInfo.title = res.data.errorMsg
                    console.log(this.nextInfo.title);
                }
            }).catch(err => {
                console.log(err.response);
            })
        }
        
    },
}
</script>

<style scoped>
.detail{
    background: #F2F3F7;
}
.container{
    height: calc(100vh - 1rem);
    overflow: auto;
}
.title{
    font-size: .3rem;
    font-weight: bold;
    padding: .4rem .96rem;
    text-align: center;
    line-height: 1.5;
    background: #fff;
}
.find{
    height: .4rem;
    padding: 0 .3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #fff;
}
.find .findNumber{
    color: #999;
}
.find .tit{
    width: 1.2rem;
    height: .4rem;
    color: #fff;
    text-align: center;
    line-height: .4rem;
    background: #D60000;
    border-radius: .06rem;
}
.content{
    padding: .3rem .3rem .4rem;
    background: #fff;
    overflow: hidden;
}
.content img{
    display: block;
    width: 6rem;
    margin: .6rem auto;
}
.content .caption{
    text-align: center;
    font-weight: bold;
    font-size: .3rem;
    margin-bottom: .3rem;
}
.content p{
    line-height: 2;
    font-size: .26rem;
    text-indent: 2em;
}
.pages{
    height: 1.3rem;
    padding-left: .28rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    margin-top: .2rem;
    background: #fff;
}
.pages div{
    font-size: .28rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.pages span{
    color: #D60000;
    margin-right: .3rem;
}
.content >>> .MsoNormal, .content >>> .p{
    text-indent: .56rem !important;
}
.content >>> .MsoNormal span span, .content >>> .MsoNormal font, .content >>> .p span span, .content >>> .p font{
    line-height: 2;
    font-size: .28rem !important;
    font-family: "微软雅黑", tahoma, arial, "Hiragino Sans GB",  simsun, sans-serif !important;
}

</style>